import {createTypes, async} from 'redux-action-creator'

export default createTypes(
  [
    ...async('FETCH'),
  ],
  'YOUR_ITEM/',
)



// WEBPACK FOOTER //
// ./src/sections/yourItems/types/item.js